module.exports = __webpack_public_path__ + "static/media/argentBankLogo.cb24b453.png";